import {IUnitDto} from '../../models/interfaces';
import {TeamMembership} from '../../../types/team-management.type';
import {createStore, withProps} from '@ngneat/elf';
import {ManageGroupDto, TeamMemberDto, UnitDto} from '../../../../userway/sdk/SSOApiClient';

export interface TeamState {
  filteredTeamMembers?: TeamMemberDto[];
  teamData?: IUnitDto;
  teamUnits: UnitDto[];
  currentTeamUnit: UnitDto | null;
  userMemberships: TeamMembership[];
  groups: ManageGroupDto[];
  filteredGroups: ManageGroupDto[];
  currentGroup: ManageGroupDto;
}

export const initialTeamData = {
  accountCode: '',
  icon: null,
  id: '',
  label: null,
  name: '',
  slug: '',
  teamMembers: {
    teamImageUri: '',
    teamImageUrl: '',
    teamMembers: [],
    teamName: '',
    teamId: '',
    mfaRequired: false,
  },
  teamMembersCount: null,
};

export function createInitialState() {
  return {
    teamData: initialTeamData,
    filteredTeamMembers: [],
    teamUnits: [],
    currentTeamUnit: null,
    userMemberships: [],
    groups: [],
    filteredGroups: [],
    currentGroup: null,
  };
}

export const teamStore = createStore({name: 'team'}, withProps<TeamState>(createInitialState()));
